import styled from "styled-components";

export const StyledButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 10rem;

  text-transform: none;
  background: ${(p) => p.$lightColor};
  color: ${(p) => p.$darkColor};

  border: 1px solid white;
  border-color: ${(p) => p.$darkColor};
  outline: none;

  border-radius: 4rem;
  padding: 1rem 2rem;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2rem;
  height: 42px;
  text-align: center;
  cursor: pointer;

  width: fit-content;

  &:active {
    scale: 0.985;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0) !important;
  }

  &:disabled {
    background: ${(p) => p.$lightColor} !important;
    scale: 1 !important;
    cursor: not-allowed;
  }

  @media (max-width: 1200px) {
    font-size: 12px;
  }
`;
